import type { ReactNode } from "react";
import cx from "classnames";

import { BodyFrame } from "common/ui/BodyFrame";
import { PageLoading } from "common/ui/PageLoading";

import styles from "./Layout.module.scss";

export function Layout() {}

function PageFrame(props: {
  isLoading?: boolean;
  title?: string;
  body?: string;
  children?: ReactNode;
  center?: boolean;
}) {
  return props.isLoading ? (
    <PageLoading progress loading={{ title: props.title, body: props.body }} />
  ) : (
    <BodyFrame className={cx({
      [styles.center]: props.center,
    })}>
      {props.children}
    </BodyFrame>
  );
}

function AdminFrame(props: {
  isLoading?: boolean;
  title?: string;
  body?: string;
  children: ReactNode;
}) {
  return props.isLoading ? (
    <PageLoading progress loading={{ title: props.title, body: props.body }} />
  ) : (
    <div className={styles.AdminFrame}>{props.children}</div>
  );
}

function ButtonFrame(props: { children: ReactNode }) {
  return <div className={styles.ButtonFrame}>{props.children}</div>;
}

function VerticalStack(props: { children: ReactNode }) {
  return <div className={styles.VerticalStack}>{props.children}</div>;
}

function TableFrame(props: { children: ReactNode }) {
  return <div className={styles.TableFrame}>{props.children}</div>;
}

function SplitRow(props: { padding?: boolean; children: ReactNode }) {
  return (
    <div className={cx(styles.SplitRow, { [styles.padding]: props.padding })}>
      {props.children}
    </div>
  );
}

function AdminSplit(props: { padding?: boolean; children: ReactNode }) {
  return (
    <div className={cx(styles.AdminSplit, { [styles.padding]: props.padding })}>
      {props.children}
    </div>
  );
}

function Sidebar(props: { children: ReactNode }) {
  return <div className={styles.Sidebar}>{props.children}</div>;
}

function EqualColumns(props: { children: ReactNode; gap32?: boolean }) {
  return (
    <div
      className={cx(styles.EqualColumns, {
        [styles.gap32]: props.gap32,
      })}
    >
      {props.children}
    </div>
  );
}

function Flex(props: {
  children: ReactNode;
  direction: "column" | "row";
  spaceBetween?: boolean;
  gap12?: boolean;
  gap16?: boolean;
  gap24?: boolean;
  gap32?: boolean;
  grow?: boolean;
  mt32?: boolean;
  my32?: boolean;
  mx24?: boolean;
}) {
  return (
    <div
      className={cx(styles.Flex, {
        [styles.column]: props.direction === "column",
        [styles.row]: props.direction === "row",
        [styles.spaceBetween]: props.spaceBetween,
        [styles.gap12]: props.gap12,
        [styles.gap16]: props.gap16,
        [styles.gap24]: props.gap24,
        [styles.gap32]: props.gap32,
        [styles.grow]: props.grow,
        [styles.mt32]: props.mt32,
        [styles.my32]: props.my32,
        [styles.mx24]: props.mx24,
      })}
    >
      {props.children}
    </div>
  );
}

Layout.PageFrame = PageFrame;
Layout.AdminFrame = AdminFrame;
Layout.ButtonFrame = ButtonFrame;
Layout.VerticalStack = VerticalStack;
Layout.TableFrame = TableFrame;
Layout.SplitRow = SplitRow;
Layout.AdminSplit = AdminSplit;
Layout.Sidebar = Sidebar;
Layout.EqualColumns = EqualColumns;
Layout.Flex = Flex;
